var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatingSolutionTubeRackEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 50,
    viewBox: "0 -50 190 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24438 89.486V50.6705L6.4718 49.2675H62.9332C62.9332 49.2675 38.8757 50.6705 28.5654 50.6705C18.255 50.6705 13.018 76.5475 11.3815 89.486H5.24438Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.755 89.486V50.6705L180.528 49.2675H124.067C124.067 49.2675 148.124 50.6705 158.434 50.6705C168.745 50.6705 173.982 76.5475 175.618 89.486H181.755Z",
    fill: "#B2B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9999 8.52196C89.9999 6.03668 92.0146 4.02197 94.4999 4.02197C96.9852 4.02197 98.9999 6.03668 98.9999 8.52196V48.2623H89.9999V8.52196Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.2568C0 48.1522 0.895429 47.2568 2 47.2568H185C186.104 47.2568 187 48.1522 187 49.2568V50.2732H0V49.2568Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 50.2734H0L2.77037 52.2843H26V51H44V52.2843H58V51H75.9999V52.2843H109V51H127V52.2843H143V51H161V52.2843H184.229L187 50.2734Z",
    fill: "#B2B2B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 92V50.2733L1.31111 48.7651H61.6221C61.6221 48.7651 35.9244 50.2733 24.9111 50.2733C13.8978 50.2733 8.30369 78.0911 6.55555 92H0Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187 92V50.2733L185.689 48.7651H125.378C125.378 48.7651 151.075 50.2733 162.089 50.2733C173.102 50.2733 178.696 78.0911 180.444 92H187Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatingSolutionTubeRackEmpty);
export default __webpack_public_path__ + "static/media/floating-solution-tube-rack-empty.4e53c15b780e8150b981d1a9eee98b7d.svg";
export { ForwardRef as ReactComponent };